// Reads the guest cart kept in the `local-cart` cookie.
// A broken value (edited by hand, left by an old version) used to throw inside
// JSON.parse and send the whole app to error.jsx; it now reads as an empty cart.
// An array is returned as it is, and a URL-encoded value (a raw `Cookie` header) is decoded first (chawk-bazar / ciseco
// read it that way on the server with their own copy of this function).
export const parse_local_cart = (raw) => {
  if (Array.isArray(raw)) return raw;
  if (typeof raw !== "string" || raw === "") return [];
  const attempts = [raw];
  try {
    attempts.push(decodeURIComponent(raw));
  } catch {
    // not encoded
  }
  for (const text of attempts) {
    try {
      const value = JSON.parse(text);
      if (Array.isArray(value)) return value;
    } catch {
      // invalid, try the next form
    }
  }
  return [];
};
